module.exports = {
    SERVICE: {
        POS: {
            ID: 192
        },
        RECONCILE: {
            ID: 193
        },
        COMMERCIAL: {
            ID: 194
        },
        CSP4: {
            ID: 198
        },
    },
    TASK: {
        PRIORITY: {
            LOW: {
                ID: 35,
                COLOR: "teal accent-1",
                TEXT: "LOW"
            },
            NORMAL: {
                ID: 36,
                COLOR: "teal accent-3",
                TEXT: "NORMAL"
            },
            HIGH: {
                ID: 37,
                COLOR: "pink",
                TEXT: "HIGH"
            },
            URGENT: {
                ID: 38,
                COLOR: "red darken-4",
                TEXT: "URGENT"
            },

        },
        STATUS: {
            INPROGRESS: {
                ID: 48,
                COLOR: "yellow",
                TEXT: "INPROGRESS"
            },
            OPEN: {
                ID: 49,
                COLOR: "red",
                TEXT: "OPEN"
            },
            CLOSED: {
                ID: 50,
                COLOR: "green",
                TEXT: "CLOSED"
            },
            WAITINGFORCUSTOMER: {
                ID: 51,
                COLOR: "blue",
                TEXT: "WAITINGFORCUSTOMER"
            },
            WAITINGFORUPDATE: {
                ID: 52,
                COLOR: "teal accent-1",
                TEXT: "WAITINGFORUPDATE"
            },
        }
    }
} 